import React from 'react';
import { TileViewComponent } from 'ui/tile-view/tile-view';
import styles from './code-mappings-tile.scss';

export const CodeMappingsTile: React.FC<React.PropsWithChildren> = ({
  children
}) => <div className="row">
    <TileViewComponent
      componentId="list-tile-column"
      className={styles.container}
      textAddItem={undefined}
      label={{ required: false, visible: false }}
      readOnly={false}>
      {children}
    </TileViewComponent>
  </div>;
